var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1536 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#001e56;}.cls-2{fill:#003bab;}.cls-3{fill:#0058ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M920,1024H0V0H920c6.8,2.39,11.33,7.71,15.75,12.89,7.57,8.88,16,17,23.93,25.48q37.59,40.07,74.15,81.06,42.93,48.07,84.11,97.64c28.71,34.39,56.62,69.44,84.11,104.82,40,51.44,78.38,104,115.86,157.31,7.31,10.4,14.85,20.67,21.16,31.75a1.83,1.83,0,0,1,.22,1.46q-6.59,10.44-13.64,20.59-67,96.82-139.84,189.31-43.72,55.56-89.38,109.57c-17.56,20.69-35.17,41.35-53.19,61.65-13.59,15.31-27.22,30.6-41.07,45.69-24,26.13-47.91,52.3-72.81,77.57A35.24,35.24,0,0,1,920,1024Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M920,1024c.73-2.14,2.46-3.52,3.95-5.08,11.83-12.42,23.77-24.75,35.51-37.26q38.3-40.81,75.43-82.71,67.68-76.28,131.27-156,72.81-91.25,140-186.69c9.68-13.77,19.22-27.63,28.83-41.44.66-1,1.38-1.87,2.07-2.81,2.93-1.74,3.91.86,5,2.48,11,16.12,22.1,32.11,32.72,48.47,18.5,28.51,37.07,57,55,85.85,28.56,46,56.4,92.44,83,139.63,6.13,10.89,12.22,21.8,18.46,32.62,2.56,4.44,3,9.36,4.81,13.94v189Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1337.05,511a26.22,26.22,0,0,1-4.28-5.5q-49.35-72-101.93-141.58-67-88.8-139-173.67-42.39-49.92-86.36-98.46c-16.48-18.13-33-36.18-49.9-53.95q-16.51-17.4-33.06-34.78c-.91-1-1.72-2-2.57-3h616V188c-1.93,12.37-9.27,22.3-15.17,32.78-22,39-44.43,77.82-67.78,116.07-30.64,50.19-62.13,99.84-95,148.63-5.2,7.73-10.62,15.33-15.72,23.14C1341.12,510.53,1339.88,512.56,1337.05,511Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1337.05,511a16,16,0,0,0,3.42-4.26q31.4-46,61.41-92.92,36.22-56.58,70.5-114.36,31.06-52.42,60.48-105.8,1.56-2.84,3.14-5.65V835c-.71-1.12-1.47-2.21-2.11-3.37q-58.55-106.35-123.63-208.81-33.73-53.12-69.14-105.14c-1.31-1.92-2.72-3.78-4.08-5.67C1337.05,511.67,1337.05,511.33,1337.05,511Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackground);
export default __webpack_public_path__ + "static/media/auth-background.213d347cb9fa11ce9a8a3688009e8aa0.svg";
export { ForwardRef as ReactComponent };